import styled, { css } from 'styled-components/macro'
import { Scrollbars } from 'rc-scrollbars'

import { theme, fluidSystem, OptionButtonInner, mediaM, mediaS, mediaShort } from 'styled'

export const Root = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const ContentRow = styled.div`
  ${fluidSystem};
  width: 100%;
  display: flex;
  flex: 0 0 auto;
  background-color: ${({ isBottom }) => (isBottom ? theme.colors.lightGrey : 'transparent')};

  ${mediaShort`
    ${({ isBottom }) =>
      isBottom &&
      css`
        height: 60px;
      `}
  `};
`

export const BodyRow = styled(ContentRow)`
  position: relative;
  flex: 0 999 100%;
  width: 100%;
  /* height: 100%; */

  &:after,
  &:before {
    content: '';
    position: absolute;
    left: 0;
    width: 100%;
    height: 10px;
    transition: opacity 0.3s;
    z-index: 1;
  }

  &:before {
    top: 0;
    background-image: linear-gradient(rgba(221, 221, 221, 0.25) 0%, rgba(221, 221, 221, 0) 100%);
    opacity: ${({ shadows }) => (shadows.top ? 1 : 0)};
  }

  &:after {
    bottom: 0;
    background-image: linear-gradient(rgba(221, 221, 221, 0) 0%, rgba(221, 221, 221, 0.25) 100%);
    opacity: ${({ shadows }) => (shadows.bottom ? 1 : 0)};
  }

  > .Inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
`

export const SideColumn = styled.div`
  ${fluidSystem};
  flex: 1 0 auto;
  border-right: 1px solid rgba(221, 221, 221, 0.5);
  display: none;

  ${mediaM`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100%;
  `};

  ${mediaShort`
    padding: 0 40px;
  `};
`

export const CenterColumn = styled.div`
  position: relative;
  flex: 0 999 100%;
`

export const CenterInner = styled.div`
  ${fluidSystem};
  position: absolute;
  top: 0;
  left: 50%;
  width: 100%;
  height: 100%;
  max-width: 800px;
  transform: translate(-50%, 0);
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 40px;

  > * + * {
    margin-left: 16px;
  }

  ${mediaS`
    padding-top: 0px;
  `};

  ${mediaM`
    justify-content: flex-start;
  `};
`

export const ResultCircle = styled.div`
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid ${theme.colors.primary};
`

export const NavButton = styled(OptionButtonInner)`
  width: 60px;
  opacity: ${({ enabled }) => (enabled ? 1 : 0.5)};
  pointer-events: ${({ enabled }) => (enabled ? 'all' : 'none')};

  ${mediaS`
    width: 120px;
  `};

  > span:first-of-type {
    display: none;
    ${mediaS`
      display: flex;
      `};
  }

  > .Icon {
    ${mediaS`
      display: none;
      `};
  }

  &.HomeButton {
    ${mediaS`
      width: 150px;
    `};
    ${mediaM`
      display: none;
    `};
  }
`

export const ResultTransitionWrapper = styled.div`
  ${fluidSystem};
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`

export const BackLink = styled.div`
  ${fluidSystem};
  display: inline-block;
  text-transform: uppercase;
  padding-bottom: 2px;
  border-bottom: 1px solid;

  > div {
    transition: transform 0.2s;
  }

  &:hover {
    cursor: pointer;
    div {
      transform: translate(0, -4px);
    }
  }
`

export const ScrollbarsWrapper = styled(Scrollbars)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  > .rc-scrollbars-view {
    overflow-x: hidden !important;
  }
`
export const ScrollbarsInner = styled.div`
  ${fluidSystem};
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
`
export const TrackY = styled.div`
  border-radius: 3px;
  height: calc(100% - 20px);
  overflow: hidden;
  position: absolute;
  right: 4px;
  top: 10px;
  user-select: none;
  width: 6px;
  background-color: rgba(221, 221, 221, 0.5);
  display: none;

  ${mediaM`
    display: block;
  `}
`

export const TrackX = styled.div`
  display: none;
`

export const ThumbY = styled.div`
  cursor: pointer;
  border-radius: 3px;
  width: 100%;
  background-color: ${theme.colors.primary};
  opacity: 0.5;
`
